import React, { useMemo, useState } from "react";

import { Image, Range } from "../../types";
import { BackgroundImage } from "./BackgroundImage";

type Props = Readonly<{
  gutterWidth: number;
  height: number;
  images: ReadonlyArray<Image>;
  markPageReady: (page: number) => void;
  pageRanges: ReadonlyArray<Range>;
  readyPages: Array<boolean>;
  scale: number;
  width: number;
}>;

export const Background = ({
  gutterWidth,
  height,
  images,
  markPageReady,
  pageRanges,
  readyPages,
  scale,
  width,
}: Props) => {
  const canvasStyles = useMemo(
    () => ({
      height: `${height}px`,
      width: `${width}px`,
    }),
    [height, width],
  );
  const [canvasRef, setCanvasRef] = useState<HTMLCanvasElement | null>(null);
  let backgroundImages;
  if (canvasRef) {
    const context = canvasRef.getContext("2d");
    if (context) {
      backgroundImages = images.map((i, index) => {
        const image = (
          <BackgroundImage
            context={context}
            key={i.src}
            height={i.height * scale}
            index={index}
            markPageReady={markPageReady}
            readyPages={readyPages}
            src={i.src}
            x={gutterWidth}
            y={pageRanges[index].start}
            width={i.width * scale}
          />
        );
        return image;
      });
    }
  }
  return (
    <div className="position-relative">
      <canvas
        className="background"
        height={height}
        ref={setCanvasRef}
        style={canvasStyles}
        width={width}
      />
      {backgroundImages}
    </div>
  );
};
Background.displayName = "Background";
